<h2 mat-dialog-title>{{ 'auth.link_account' | translate }}<span class="icon-close icon-Cross" mat-dialog-close></span></h2>
<mat-dialog-content>
  <div class="dialog-content">
    <h3><img src="./assets/images/google-icon.svg" alt="Google" /> {{ 'auth.link_account_title' | translate }}</h3>
    <p>{{ 'auth.link_account_message' | translate: { email: data.email } }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button class="btn-main btn-secondary-purple btn-xl" mat-dialog-close>{{ 'auth.link_account_cancel' | translate }}</button>
  <button class="btn-main btn-primary btn-xl" (click)="confirm()">{{ 'auth.link_account_agree' | translate }}</button>
</mat-dialog-actions>
